const GoogleWallet = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 32 32' fill='none'>
			<path
				d='M0 7.31422C0 4.53701 2.25137 2.28564 5.02857 2.28564H26.9714C29.7486 2.28564 32 4.53701 32 7.31422V24.6856C32 27.4628 29.7486 29.7142 26.9714 29.7142H5.02857C2.25137 29.7142 0 27.4628 0 24.6856V7.31422Z'
				fill='#35A659'
			/>
			<path
				d='M0 11.6572C0 8.88003 2.25137 6.62866 5.02857 6.62866H26.9714C29.7486 6.62866 32 8.88003 32 11.6572V24.6858C32 27.463 29.7486 29.7144 26.9714 29.7144H5.02857C2.25137 29.7144 0 27.463 0 24.6858V11.6572Z'
				fill='#FABE36'
			/>
			<path
				d='M0 15.7715C0 12.9943 2.25137 10.7429 5.02857 10.7429H26.9714C29.7486 10.7429 32 12.9943 32 15.7715V24.6858C32 27.463 29.7486 29.7143 26.9714 29.7143H5.02857C2.25137 29.7143 0 27.463 0 24.6858V15.7715Z'
				fill='#E84D3E'
			/>
			<path
				d='M0 13.9429L20.1375 18.7148C22.6623 19.3131 25.3226 18.7816 27.4237 17.2591L32 13.9429V24.6857C32 27.4629 29.7486 29.7143 26.9714 29.7143H5.02857C2.25137 29.7143 0 27.4629 0 24.6857V13.9429Z'
				fill='#4983EE'
			/>
		</svg>
	);
};

export default GoogleWallet;
